import React from 'react';
import Suggestion from './Suggestion';

const Suggestions = ({
  places = [],
  hasResults,
  clickHandler,
  cursorIdx,
  mouseInSuggestions,
  getMouseInSuggestions,
  selectColor,
  isTouch
}) => {
  const handleMouseEnter = () => {
    getMouseInSuggestions(true);
  };

  const handleMouseLeave = () => {
    getMouseInSuggestions(false);
  };

  return (
    <span
      className="suggestionsWrapper"
      style={{ display: hasResults ? 'flex' : 'none' }}
    >
      <div
        className="suggestionsList"
        onMouseEnter={!isTouch ? handleMouseEnter : undefined}
        onMouseLeave={!isTouch ? handleMouseLeave : undefined}
      >
        {places.map((place, idx) => (
          <Suggestion
            selectColor={selectColor}
            mouseInSuggestions={mouseInSuggestions}
            idx={idx}
            isTouch={isTouch}
            cursorIdx={cursorIdx}
            clickHandler={clickHandler}
            key={place.formattedAddress}
            place={place}
          />
        ))}
      </div>
    </span>
  );
};

export default Suggestions;
